import { environment } from './../../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class CacheCodAlternativoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  editCache(cacheId: number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));
    console.log(sessionStorage.getItem('ticket-ECM'));
    return this.httpClient.post(this.apiURL + `/set-cache-cod-alternativo-unico/${cacheId}`, {}, {headers, responseType: 'text'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/caixa/cache-cod-alternativo.service.ts